// import * as React from "react";
// import * as SliderPrimitive from "@radix-ui/react-slider";

// import { cn } from "../../lib/utils";

// function Slider({
//   className,
//   defaultValue,
//   value,
//   min = 0,
//   max = 100,
//   ...props
// }: React.ComponentProps<typeof SliderPrimitive.Root>) {
//   const _values = React.useMemo(
//     () =>
//       Array.isArray(value)
//         ? value
//         : Array.isArray(defaultValue)
//         ? defaultValue
//         : [min, max],
//     [value, defaultValue, min, max]
//   );

//   return (
//     <SliderPrimitive.Root
//       data-slot="slider"
//       defaultValue={defaultValue}
//       value={value}
//       min={min}
//       max={max}
//       className={cn(
//         "relative flex w-full touch-none items-center select-none data-[disabled]:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col",
//         className
//       )}
//       {...props}
//     >
//       <SliderPrimitive.Track
//         data-slot="slider-track"
//         className={cn(
//           "bg-white/30 relative grow overflow-hidden rounded-full data-[orientation=horizontal]:h-2.5 data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1.5"
//         )}
//       >
//         <SliderPrimitive.Range
//           data-slot="slider-range"
//           className={cn(
//             "bg-white absolute data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full"
//           )}
//         />
//       </SliderPrimitive.Track>
//       {Array.from({ length: _values.length }, (_, index) => (
//         <SliderPrimitive.Thumb
//           data-slot="slider-thumb"
//           key={index}
//           className={cn(
//             "block size-4 shrink-0 rounded-full border border-white bg-white cursor-pointer",
//             "shadow-[0_0_20px_7px_rgba(255,255,255,0.85)]",
//             "hover:shadow-[0_0_20px_7px_rgba(255,255,255,1)] focus-visible:shadow-[0_0_24px_8px_rgba(255,255,255,0.95)]",
//             "transition-shadow focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50"
//           )}
//         />
//       ))}
//     </SliderPrimitive.Root>
//   );
// }

// export { Slider };


import * as React from "react";
import * as SliderPrimitive from "@radix-ui/react-slider";

import { cn } from "../../lib/utils";

function Slider({
  className,
  defaultValue,
  value,
  min = 0,
  max = 100,
  onValueChange,
  onChangeEnd,   // <-- add new prop
  ...props
}: React.ComponentProps<typeof SliderPrimitive.Root> & {
  onChangeEnd?: (value: number[]) => void;
}) {
  const _values = React.useMemo(
    () =>
      Array.isArray(value)
        ? value
        : Array.isArray(defaultValue)
        ? defaultValue
        : [min, max],
    [value, defaultValue, min, max]
  );

  // Store latest value
  const lastValueRef = React.useRef(_values);

  return (
    <SliderPrimitive.Root
      data-slot="slider"
      defaultValue={defaultValue}
      value={value}
      min={min}
      max={max}
      onValueChange={(v) => {
        lastValueRef.current = v;
        onValueChange?.(v);
      }}
      // Detect end of sliding
      onPointerUp={() => {
        if (onChangeEnd) onChangeEnd(lastValueRef.current);
      }}
      onTouchEnd={() => {
        if (onChangeEnd) onChangeEnd(lastValueRef.current);
      }}
      className={cn(
        "relative flex w-full touch-none items-center select-none data-[disabled]:opacity-50 data-[orientation=vertical]:h-full data-[orientation=vertical]:min-h-44 data-[orientation=vertical]:w-auto data-[orientation=vertical]:flex-col",
        className
      )}
      {...props}
    >
      <SliderPrimitive.Track
        data-slot="slider-track"
        className={cn(
          "bg-white/30 relative grow overflow-hidden rounded-full data-[orientation=horizontal]:h-2.5 data-[orientation=horizontal]:w-full data-[orientation=vertical]:h-full data-[orientation=vertical]:w-1.5"
        )}
      >
        <SliderPrimitive.Range
          data-slot="slider-range"
          className={cn(
            "bg-white absolute data-[orientation=horizontal]:h-full data-[orientation=vertical]:w-full"
          )}
        />
      </SliderPrimitive.Track>

      {Array.from({ length: _values.length }, (_, index) => (
        <SliderPrimitive.Thumb
          data-slot="slider-thumb"
          key={index}
          className={cn(
            "block size-4 shrink-0 rounded-full border border-white bg-white cursor-pointer",
            "shadow-[0_0_20px_7px_rgba(255,255,255,0.85)]",
            "hover:shadow-[0_0_20px_7px_rgba(255,255,255,1)] focus-visible:shadow-[0_0_24px_8px_rgba(255,255,255,0.95)]",
            "transition-shadow focus-visible:outline-none disabled:pointer-events-none disabled:opacity-50"
          )}
        />
      ))}
    </SliderPrimitive.Root>
  );
}

export { Slider };

